import { SET_MENU_OPEN } from "constants-lib/actionTypes"

export const setMenuOpen = (isMenuOpen) => ({
  type: SET_MENU_OPEN,
  payload: {
    isMenuOpen,
  },
})
